module.exports = __webpack_public_path__ + "img/sn-fb-dark.60cbfa2a.svg";